import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { DownloadComponent } from "src/app/shared/components/download/download.component";
import { Group } from "src/app/shared/models/group.model";
import Swal from "sweetalert2";
import { AdminService } from "../../admin/admin-service";
import { ApplicationCdoViewComponent } from "../../applications/application-cdo-view/application-cdo-view.component";
import { StorageService } from "../../services/storage.service";
import { StorageKey } from "../../storage.model";

@Component({
  selector: "app-dcdo-view",
  templateUrl: "./dcdo-view.component.html",
  styleUrls: ["./dcdo-view.component.scss"],
})
export class DcdoViewComponent implements OnInit {
  profile: any;
  group: Group;
  subs: Subscription[] = [];
  formGroup: FormGroup;
  status_list: any;
  description: any;
  info: string;
  user: any;
  user_data: any;
  principal: any;
  position: any;
  profile_status: boolean;
  groupId: any;
  attachment_status: boolean;
  attachment_list: any;
  member_status: boolean;
  members_list: any;
  group_economic_list: any;
  activities: boolean;
  leader_list: any;
  leader_status: boolean;
  dcdo_status: boolean;
  constructor(
    private dialogRef: MatDialogRef<ApplicationCdoViewComponent>,
    private toast: ToastrService,
    private service: AdminService,
    private storeSvc: StorageService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    this.profile = data.data;
    console.log("Profile", this.profile);
    if (this.profile) {
      this.profile_status = true;
    }
    this.group = this.profile;
    console.log("Group ", this.group);
    this.groupId = this.profile.id;
    if (this.groupId) {
      this.memberList(this.groupId);
      this.leaderList(this.groupId);
      this.economicList(this.groupId);
      this.attachmentList(this.groupId);
      this.groupStatus(this.groupId);
    }
    this.info = localStorage.getItem("userInfo");
    if (this.info) {
      this.user = this.storeSvc.read(StorageKey.CURRENT_USER);
      this.user_data = this.user.data;
      if (this.user_data) {
        this.principal = this.user_data.principal;
        this.position = this.principal.position.name;
        if (this.position === "DCDO") {
          this.dcdo_status = true;
        } else {
          this.dcdo_status = false;
        }
        console.log("Position", this.position);
      }
    }
  }

  ngOnInit(): void {
    this.formGroup = this.initFormGroup();
  }

  attachmentList(param) {
    this.attachment_status = false;
    this.subs.push(
      this.service.groupAttachment(param).subscribe((response) => {
        this.attachment_list = response.data;

        if (this.attachment_list) {
          this.attachment_status = true;
        }
      })
    );
  }

  memberList(param) {
    this.member_status = false;
    this.subs.push(
      this.service.memberByProfile(param).subscribe((response) => {
        this.members_list = response.data;

        if (this.members_list) {
          this.member_status = true;
        } else {
          Swal.fire("No Members", "Please Add Members", "warning");
        }
      })
    );
  }

  leaderList(param) {
    this.leader_status = false;
    this.subs.push(
      this.service.leaderByProfile(param).subscribe((response) => {
        this.leader_list = response.data;

        if (this.leader_list) {
          this.leader_status = true;
        }
      })
    );
  }

  groupStatus(param) {
    this.service.groupStatus(param).subscribe((response) => {
      this.status_list = response["data"];
    });
  }

  getColor(status) {
    switch (status) {
      case "Submitted":
        return "#26A69A";
      case "Initiated":
        return "#008dc9";
      case "Verified":
        return "green";
      case "#4CAF50":
        return "orange";
      case "Rejected":
        return "red";
      case "Declined":
        return "red";
      case "Approved":
        return "#2196F3";
    }
  }

  download(param) {
    const data = {
      title: "Download",
      action: "create",
      dataBinary: param.fileBase64,
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "70%";
    dialogConfig.height = "80%";
    dialogConfig.data = data;
    dialogConfig.panelClass = "mat-dialog-box";
    const dl = this.dialog.open(DownloadComponent, dialogConfig);
    this.subs.push(
      dl.afterClosed().subscribe(
        (response: any) => {
          //this.attachmentList(this.groupId);
        },
        (error) => {}
      )
    );
  }

  economicList(param) {
    this.subs.push(
      this.service.groupEconomic(param).subscribe((response) => {
        this.group_economic_list = response.data["sectors"];
        if (this.group_economic_list) {
          this.activities = true;
        }
      })
    );
  }

  initFormGroup(): FormGroup {
    return this.formBuilder.group({
      comment: ["", Validators.required],
    });
  }

  save(param) {
    const payload = {
      comment: param.comment,
      statusId: 3,
      groupProfileId: this.profile.id,
      closed: this.profile.closed,
    };

    if (payload) {
      this.saveProfile(payload);
    }
  }

  reject(param) {
    const payload = {
      comment: param.comment,
      statusId: 5,
      groupProfileId: this.profile.id,
      closed: this.profile.closed,
    };

    if (payload) {
      this.saveProfile(payload);
    }
  }

  decline(param) {
    const payload = {
      comment: param.comment,
      statusId: 6,
      groupProfileId: this.profile.id,
      closed: this.profile.closed,
    };

    if (payload) {
      this.saveProfile(payload);
    }
  }

  status() {
    this.service.status().subscribe((response) => {
      this.status_list = response.data;
    });
  }

  saveProfile(param) {
    this.service.submitApplication(param).subscribe((response) => {
      this.description = response.description;
      if (this.description) {
        this.description = this.description;
      } else {
        this.description = "Process Failed";
      }
      if (response.code === 200) {
        //Swal.fire(response.description, "", "success");
        this.dialogRef.close();
      } else {
        //Swal.fire(response.description, "", "error");
      }
    });
  }
}
